// import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
// import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { AllLockerAssignTableDataColumnType, AllLockerAssignTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const allLockerAssignTableData = [
    {
      lockerCalculationId: 1019,
      bigLocker: "0",
      smallLocker: "1",
      subTotalAmount: 100,
      gst: 5,
      grandTotalAmount: 399,
      isLocked: true,
      ticketRFIdRef: "REF-SWP-2311",
      selectedCard: "1",
      lockerNumber: "17,18",
      lockerId: 1017
    },
    {
      lockerCalculationId: 1020,
      bigLocker: "1",
      smallLocker: "0",
      subTotalAmount: 200,
      gst: 10,
      grandTotalAmount: 420,
      isLocked: false,
      ticketRFIdRef: "REF-SWP-4893",
      selectedCard: "2",
      lockerNumber: "12",
      lockerId: 1018
    }
];

// const ProductListTableAction = ({adultPlanId}) => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <button className="btn btn-sm">
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//       </button>
//       <p>{adultPlanId}</p>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
    try {
      await api.delete(`/api/LockerCalculation/ReturnRFIDCard?lockerCalculationId=${id}`);
      Swal.fire('Return!', '  Locker has been return submitted.', 'success');
  
      // Optional: refresh the list
    //   setCardAssignTableDatas((prev) => prev.filter((item: { adultPlanId: any; }) => item.adultPlanId !== id));
    } catch (error) {
      Swal.fire('Error!', 'Failed to submit return the record.', 'error');
      console.error("Return error:", error);
    }
  };

interface ProductListTableActionProps {
    lockerCalculationId: any;
  onDelete: (id: number) => void;
}

export const AllLockerAssignTableAction: React.FC<ProductListTableActionProps> = ({ lockerCalculationId, onDelete }) => {

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, return it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(lockerCalculationId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <span className="bg-danger text-white p-2 rounded" title="Return Locker" onClick={handleDeleteClick}>
        {/* Return Lockers */}
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 7v4H6.83l3.59-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21V7z"/>
        </svg>
      </span>
    </div>
  );
};

export const AllLockerAssignTableProductName: React.FC<AllLockerAssignTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const AllLockerAssignTableStatus :React.FC<AllLockerAssignTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export const allLockerAssignTableDataColumn: TableColumn<AllLockerAssignTableDataColumnType>[] = [
  {
    name: "Ticket ID",
    cell: (row) => <AllLockerAssignTableProductName title={row.ticketRFIdRef}/>,
    sortable: true,
    grow: 2,
  },
  {
    name: "RFID Card No.",
    selector: (row) => `${row.selectedCard}`,
    sortable: true,
    grow: 2,
  },
  {
    name: "Locker Number",
    selector: (row) => `${row.lockerNumber}`,
    sortable: true,
  },
  {
    name: "Big Locker",
    selector: (row) => `${row.bigLocker}`,
    sortable: true,
  },
  {
    name: "Small Locker",
    selector: (row) => `${row.smallLocker}`,
    sortable: true,
  },
  {
    name: "Locker Amount",
    selector: (row) => `${row.subTotalAmount}`,
    sortable: true,
  },
  {
    name: "GST",
    selector: (row) => `${row.gst}`,
    sortable: true,
  },
  {
    name: "Grand Total Amount",
    selector: (row) => `${row.grandTotalAmount}`,
    sortable: true,
  },
  {
    name: "Status",
    cell: (row) =>  <AllLockerAssignTableStatus title={row.isLocked ? "Active" : "Inactive"} />,
  },
  {
    name: "Action",
    cell: (row) => <AllLockerAssignTableAction lockerCalculationId={row.lockerCalculationId} onDelete={handleDelete} />,
  },
  ];

  export const filtersData = [
    {
      name: "Choose Ticket ID",
      options: ["SWP-4893", "SWP-2311"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
    {
      name: "customerMobileNumber",
      options: ["8347821920"],
    },
  ];